export default __webpack_public_path__ + "static/media/3-2.b409232f.mp3";